import { AnyAction } from "redux"

import { CLEAN_EVENT_TYPE, CLOSE_MODAL, OPEN_MODAL, SET_EVENT_TYPE, SET_EVENT_TYPE_LIST } from "./actions-types"

export interface EventTypeState {
  modal: {
    type: "create" | "update" | "delete" | ""
    state: boolean
  }
  event: {
    key: string
    name: string
    price: number
    hasFreeTrial: boolean
    product: string
    isSimplePricing: boolean
    currencyType: string
    purchasePlan: string
    account: string
    freeTrialDuration: {
      unit?: string
      amount?: number
      usageLimit: number
    }
    isPublished: boolean
  }
  eventList: App.EventType[]
}

const INITIAL_STATE: EventTypeState = {
  modal: {
    type: "",
    state: false
  },
  event: {
    key: "",
    name: "",
    price: 0,
    hasFreeTrial: false,
    product: "",
    isSimplePricing: false,
    currencyType: "",
    purchasePlan: "",
    account: "",
    freeTrialDuration: {
      usageLimit: 0
    },
    isPublished: true
  },
  eventList: []
}

//This redux reducer is used to manage the state of the event types
export default function eventTypesReducer(state: EventTypeState = INITIAL_STATE, action: AnyAction): EventTypeState {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        modal: {
          type: action.payload.type,
          state: true
        }
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modal: {
          type: "",
          state: false
        }
      }
    case SET_EVENT_TYPE:
      return {
        ...state,
        event: {
          ...state.event,
          key: action.payload.key,
          name: action.payload.name,
          price: action.payload.price,
          hasFreeTrial: action.payload.freeTrial,
          product: action.payload.product,
          isSimplePricing: action.payload.isSimplePricing,
          currencyType: action.payload.currencyType,
          purchasePlan: action.payload.purchasePlan,
          account: action.payload.account,
          freeTrialDuration: action.payload.freeTrialDuration,
          isPublished: action.payload.isPublished
        }
      }
    case CLEAN_EVENT_TYPE:
      return {
        ...state,
        event: {
          key: "",
          name: "",
          price: 0,
          hasFreeTrial: false,
          product: "",
          isSimplePricing: false,
          currencyType: "",
          purchasePlan: "",
          account: "",
          freeTrialDuration: {
            usageLimit: 0
          },
          isPublished: true
        }
      }

    case SET_EVENT_TYPE_LIST:
      return {
        ...state,
        eventList: action.payload
      }

    default:
      return state
  }
}
